import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../views/Main.vue'
import Details from '../views/details/index.vue'
import Categroy from '../views/categroy/index.vue'
import Cart from '../views/cart/index.vue'
import Order from '../views/order/index.vue'
import Search from '../views/search/index.vue'
import Check from '../views/check/index.vue'
import Contact from '../views/contact/index.vue'
import Page from '../views/page.vue'
import Nav from '../views/nav.vue'
import Article from '../views/article/index.vue'
import ArticlePage from '../views/article/page.vue'
Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'main',
    component: Main
  },
  {
    path: '/details/:id',
    name: 'details',
    component: Details
  },
  {
    path: '/categroy/:name/:id',
    name: 'categroy',
    component: Categroy
  },
  {
    path: '/cart',
    name: 'cart',
    component: Cart
  },
  {
    path: '/search/:keyword',
    name: 'search',
    component: Search
  },
  {
    path: '/order/:id',
    name: 'order',
    component: Order
  },
  {
    path: '/check',
    name: 'check',
    component: Check
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact
  },
  {
    path: '/page/:name',
    name: 'page',
    component: Page
  },
  {
    path: '/nav/:name',
    name: 'nav',
    component: Nav
  },
  {
    path: '/article',
    name: 'article',
    component: Article
  },
  {
    path: '/article/:id',
    name: 'articlePage',
    component: ArticlePage
  }

]

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
})
// 如果你需要自定义 push 方法，也可以在这里进行
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
export default function createRouter() {
  const router = new VueRouter({
    routes,
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
      // 始终滚动到顶部
      if (savedPosition) {
        return savedPosition
      } else {
        return {
          x: 0,
          y: 0
        }
      }
    },
  })
  return router
}